export default __webpack_public_path__ + "static/863-52b938496163ec99e3ddc0ed412f0a84.gif";